import { SET_ISREADY } from './../../actionTypes'
export const setIsReady = () => (dispatch) => {
  dispatch({ type: SET_ISREADY })
}
